import { render, staticRenderFns } from "./TourBookingAirlines.vue?vue&type=template&id=1ce898a7&scoped=true"
import script from "./TourBookingAirlines.vue?vue&type=script&lang=js"
export * from "./TourBookingAirlines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce898a7",
  null
  
)

export default component.exports